// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/airfoil-anatomy.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/airfoil-anatomy/airfoil-anatomy.js';

mount([g0]);
